import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Romina G.',
    location: 'Buenos Aires | Departamento piso 8',
    quote: 'Compré un domingo a la noche. El lunes empecé el protocolo con todo claro. Las 3 semanas del Tomo 2 son exactamente lo que necesitaba para mi caso. Nunca más improvisé una salida.',
    initials: 'RG'
  }, {
    name: 'Diego M.',
    location: 'Córdoba | Edificio con consorcio activo',
    quote: 'El sistema de seguimiento con fichas mensuales eliminó las preguntas de "¿cuándo va a mejorar?". Ahora yo mismo lo veía avanzar con números reales. En semana 3 el consorcio dejó de quejarse.',
    initials: 'DM'
  }, {
    name: 'Laura V.',
    location: 'Rosario | Dueña de rescatado con trauma',
    quote: 'El Tomo 6 de casos extremos es único. Mi perra rescatada tenía un nivel de ansiedad muy alto. El protocolo específico para rescatados fue lo que cambió todo. Nada de lo que había probado antes había funcionado así.',
    initials: 'LV'
  }, {
    name: 'Marcelo A.',
    location: 'CABA | Departamento en planta baja',
    quote: 'Mi tasa de noches sin incidentes pasó del 20% al 90%. Sin cambiar nada más que el protocolo de salida y el ESA. En 3 semanas mi perro duerme tranquilo y yo también.',
    initials: 'MA'
  }, {
    name: 'Carolina L.',
    location: 'Mendoza | Dueña con horario de trabajo largo',
    quote: 'El Plan B para dueños con horarios irregulares me salvó. Antes pensaba que era imposible aplicar un protocolo con mis horarios. El Tomo 2 tiene una variante para exactamente mi situación. Este mes cobré... digo, viví, el mes completo sin conflictos.',
    initials: 'CL'
  }, {
    name: 'Analía R.',
    location: 'Salta | Perra con ansiedad severa',
    quote: 'El Atlas Visual de Señales del Acelerador me cambió todo. Por fin supe qué estaba mirando cuando mi perra hacía cosas raras. Entendí que estaba ignorando señales de estrés desde hace meses. Con esa info sola, todo mejoró en una semana.',
    initials: 'AR'
  }];
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-296">
      <div className="text-center mb-12" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center justify-center gap-3 mb-4" data-id="element-298">
          <Heart className="w-8 h-8 text-red-400 fill-red-400 mb-2" data-id="element-299" />
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-300">
            LO QUE DICEN LOS DUEÑOS QUE YA LO USAN
          </h2>
          <p className="text-blue-200 text-lg mt-2" data-id="element-301">
            +500 dueños de todo el país ya tienen su Guía
          </p>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-302">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/40 border border-navy-700 p-8 rounded-2xl flex flex-col" data-id="element-303">
            <div className="flex gap-1 mb-4" data-id="element-304">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-400 text-gold-400" data-id="element-305" />)}
            </div>
            <p className="text-base text-blue-50 italic mb-6 leading-relaxed flex-grow" data-id="element-306">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-navy-700/50" data-id="element-307">
              <div className="w-10 h-10 rounded-full bg-navy-700 flex items-center justify-center text-gold-400 font-bold shrink-0" data-id="element-308">
                {t.initials}
              </div>
              <div data-id="element-309">
                <p className="text-white font-bold text-sm" data-id="element-310">{t.name}</p>
                <p className="text-blue-200/60 text-xs flex items-center gap-1" data-id="element-311">
                  📍 {t.location}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}